import { RecordBase } from '../../providers/request/record-base.model';
import { WorkReportStatus } from '../form/work-report-status.enum';

export class JgPhysicalInspReportFile extends RecordBase {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  jgFbId?: number;
  dwCode?: string;
  jgFbName?: string;
  jgRfiIds?: Array<number>;
  fileId?: string;
  fileSn?: string;
  fileMd5?: string;
  fileCode?: string;
  fileName?: string;
  fileSubmitDate?: number;
  fileSubmitDateDate?: Date;
  fileFinishDate?: number;
  fileFinishDateDate?: Date;
  workReportId?: number;
  workFlowId?: number;
  status?: WorkReportStatus;
  comment?: string;
}
